$(document).ready(function () {
    // Open the popup when "Remind Me" button is clicked
    $('.button_remind-me').on('click', function () {
        $('#phone-number-remind').val(''); // Clear the input field
        $('#error-message').hide(); // Hide the error message if it was previously shown
        $('#popup').css('display', 'block'); // Show the popup
        $('body').css('overflow', 'hidden'); // Prevent body scrolling
    });

    // Close the popup
    $('#close-popup-button').on('click', function () {
        $('#popup').css('display', 'none'); // Hide the popup
        $('body').css('overflow', ''); // Restore body scrolling
    });

    // Handle form submission
    $('#submit-phone-button').on('click', function () {
        var phoneNumber = $('#phone-number-remind').val().trim(); // Get the trimmed value of the input field

        // Regular expressions for repetitive and sequential numbers
        const repetitivePattern = /^(\d)\1{9}$/; // Matches numbers like 8888888888 or 7777777777
        const sequentialPattern = /^(0123456789|1234567890|9876543210)$/; // Matches sequential numbers

        // Validate the phone number to ensure it starts with 6, 7, 8, or 9, is exactly 10 digits long, and is not repetitive or sequential
        if (!/^[6-9]\d{9}$/.test(phoneNumber) || repetitivePattern.test(phoneNumber) || sequentialPattern.test(phoneNumber)) {
            $('#error-message').show(); // Display the error message if the validation fails
        } else {
            $('#error-message').hide(); // Hide the error message if the validation passes
            $('#popup').css('display', 'none'); // Hide the popup before showing the alert
            $('body').css('overflow', ''); // Restore body scrolling
            alert('Thanks for submitting'); // Show the alert message

            // Call function to send data to Google Sheet
            sendDataToGoogleSheet(phoneNumber);
        }
    });

    // Optional: Hide the error message when user focuses on the input field again
    $('#phone-number-remind').on('focus', function () {
        $('#error-message').hide(); // Hide error message when user focuses on the input field
    });

    // Close the popup when clicking outside of it
    $(document).on('click', function (event) {
        var $target = $(event.target);
        if (!$target.closest('#popup').length && !$target.closest('.button_remind-me').length) {
            $('#popup').css('display', 'none'); // Hide the popup
            $('body').css('overflow', ''); // Restore body scrolling
        }
    });
});

// Function to send data to Google Sheet
const sendDataToGoogleSheet = async (userUnderBust) => {
    const url = 'https://script.google.com/macros/s/AKfycbybYbOQpfSTSOm4JI2vI74VYsMxk5eYfq9OdlT72zT1DJlJ3T2Kkx90sA8d-e2yhw9FEw/exec'; // Replace with your deployed web app URL
    const data = {
        userUnderBust: userUnderBust
    };
    try {
        const response = await fetch(url, {
            method: 'POST',
            mode: 'no-cors', // Note the no-cors mode
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        console.log('Data sent successfully to Google Sheet!');
    } catch (error) {
        console.error('Error sending data to Google Sheet:', error);
    }
};
